var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion accordion-faq"},_vm._l((_vm.contents),function(content,i){return _c('accordion-item',{key:i,ref:i,refInFor:true,class:{ 'accordion-active': content.active },attrs:{"content":content,"index":i},on:{"on-expanded":_vm.onExpanded}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }